/** 向主进程发送信息 */
import {APP_WEB, APP_WEB_WWW, isWeb} from "@/electron_interactive";

export function ipcSend(command:string,...arg:any[]){

    if (!isWeb()){
        let ipc:any = window.IPC;
        if (!window.IPC){
            ipc = window.parent.IPC
        }
        ipc?.send(command, ...arg)
    }else{
        if ('open-url' == command){
            window.open(arg[0],'_blank');
        }
    }
}

/** 向主进程获取信息 */
export function ipcInvoke(command:string,...arg:any[]){
    if (!isWeb()){
        let ipc:any = window.IPC;
        if (!window.IPC){
            ipc = window.parent.IPC
        }
        return ipc?.invoke(command, ...arg)
    }
    return new Promise(resolve => {
        resolve(null);
    })
}

export function ipcOn(command:string,arg:any){
    if (!isWeb()){
        let ipc:any = window.IPC;
        if (!window.IPC){
            ipc = window.parent.IPC
        }
        return ipc?.on(command, arg);
    }

}

export function ipcOnce(command:string,arg:any){
    if (!isWeb()){
        let ipc:any = window.IPC;
        if (!window.IPC){
            ipc = window.parent.IPC
        }
        return ipc?.once(command, arg);
    }

}

export function ipcRemove(command:string,func:any){
    if (!isWeb()){
        let ipc:any = window.IPC;
        if (!window.IPC){
            ipc = window.parent.IPC
        }
        return ipc?.remove(command, func);
    }
}
export function ipcRemoveThisAll(command:string){
    if (!isWeb()){
        let ipc:any = window.IPC;
        if (!window.IPC){
            ipc = window.parent.IPC
        }
        return ipc?.removeAllListener(command);
    }
}